<template>
    <div class="panel panel-user">
        <div class="row no-gutters icons justify-content-center">
            <ul class="nav">
                <li class="nav-item icon">
                    <router-link :to="{ name: 'portal.profile' }">
                        <img :src="profileIcon" alt="">
                        <label>{{ $t(`auth.profile`) }}</label>
                    </router-link>
                </li>
                <li class="nav-item icon mx-3">
                    <router-link :to="{ name: 'portal.home'}">
                        <img :src="PortalIcon" alt="">
                        <label>{{ $t(`auth.portal`) }}</label>
                    </router-link>
                </li>
                <li class="nav-item icon" @click="logout" v-if="$auth.check()">
                    <img :src="logoutIcon" alt="">
                    <label>{{ $t(`auth.logout`) }}</label>
                </li>
            </ul>
        </div>
        <div class="row no-gutters">
            <div class="col-sm-12 modules">
                <!-- <router-link :to="{ name: module.portal.url }" v-for="(module,index) in $root.modules" :key="index" >
                    {{module}}
                    <div class="module shadow-lg" :class="'module-login-'+index" :style="{ backgroundImage: 'url(' + require('../../../'+module.path +'platforms/'+ $root.$env.PLATFORM + '/images/logo.png') + ')' }" data-toggle="tooltip-login" data-placement="top" :data-container="'.module-login-'+index" :title="module.name">
                    </div>
                </router-link> -->
            </div>
        </div>
        <slot name="panel-section-user"></slot>
    </div>
</template>

<script>
    import UserIcon from '@images/icon-user.png';
    import LogoutIcon from '@images/icon-logout.png';
    import PortalIcon from '@images/icon-portal.png';

    export default {
        mounted() {
            $('[data-toggle="tooltip-login"]').tooltip()
        },
        computed: {
            profileIcon() {
                return UserIcon;
            },
            logoutIcon() {
                return LogoutIcon;
            },
            portalIcon() {
                return PortalIcon;
            },
        },
        methods: {
            logout: function() {
                this.$auth
                    .logout({
                        makeRequest: true,
                        redirect: {path: '/'},
                    });
                setTimeout(function() {
                    localStorage.clear();
                    window.location.reload(true);
                }, 500);
            }
        }
    }
</script>


<style scoped lang="scss">
    .modules{
        padding:20px;
        .module{
            position: relative;
            width: 70px;
            height: 40px;
            float: left;
            margin-right: 10px;
            margin-bottom: 4px;
            text-align: center;
            vertical-align: middle;
            line-height: 150px;
            color: #FFF;
            cursor: pointer;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            border:solid 1px #bdbdbd;

            @media screen and(max-width: 768px){
                &{
                }
            }
        }
    }
    .panel-user{
        display:none;
        width:100%;
        ul{
            list-style:none;
            padding:0px;
            margin:0px;

            li{
                margin-bottom: 15px;
                border-bottom:solid 1px #f3f1f1;
                cursor: pointer;
                p{
                    margin:0px;
                    margin-left:30px;
                }

                &:hover{
                    background-color:#c1c1c1;
                }

            }
        }
    }
    .icons{
        .icon{
            width:50px;
            text-align: center;
            cursor:pointer;
            border:0px;

            a{
                text-decoration:none;
            }

            img{
                width:38px;
                border-radius: 50%;
            }
            label{
                margin-bottom: 0px;
            }
        }
    }


    .card{
        .card-header{
            padding:0px;

            .btn{
                padding:5px 10px;
            }
        }
        .card-body{
            .no-occurrences{
                font-size: 0.8rem;
            }
            .form-group{
                margin-bottom:0px;

                .col-form-label,.form-control-plaintext{
                    padding-top:0px;
                    padding-bottom:0px;
                }
            }
        }

        hr{
            width:100%;
            border-bottom: solid 1px #c1c1c1;
        }
    }
</style>